import { Modal } from 'bootstrap';
var video_items = document.querySelectorAll('[data-img-type="video"]');
//TODO: Fix loading of modal on mobile
if (document.getElementById('single-products-video-modal')) {
    var singleProductsModal_1 = new Modal(document.getElementById('single-products-video-modal'));
    var singleProductsIframe_1 = document.getElementById('single-products-video-moda-iframe');
    if (video_items) {
        video_items.forEach(function (item) {
            item.addEventListener('click', function (e) {
                singleProductsIframe_1.src = item.dataset.videoUrl;
                singleProductsModal_1.show();
            });
        });
    }
    document.getElementById('single-products-video-modal').addEventListener('hide.bs.modal', function (e) {
        console.log('hidden');
        singleProductsIframe_1.src = '';
    });
}
